<dx-popup
    #workOrderEditorReferenceSelectorPopup
    minWidth="150px"
    minHeight="150px"
    width="60%"
    height="75%"
    title="Work Order Reference"
    [showTitle]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="closeSelector()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        class="cc-vertical-center-cell-data-grid"
                        [dataSource]="references"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [wordWrapEnabled]="true"
                        [columns]="referenceColumns"
                        [columnMinWidth]="30"
                        [columnAutoWidth]="true"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        columnResizingMode="nextColumn"
                        noDataText="No data to display"
                    >
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                        <div *dxTemplate="let cell of 'actionTemplate'">
                            <dx-button
                                type="default"
                                text="Select"
                                [icon]="iconCheck"
                                (onClick)="onReferenceSelection(cell.data)"
                            ></dx-button>
                        </div>
                        <!-- 
                            NOTE: To maintain consistency throughout the application, we have added context link to customerId and PropertyAddress.
                            Agreed with Murthy M.K
                        -->
                        <div *dxTemplate="let cell of 'propertyTemplate'">
                            <app-property-community-link
                                [communityId]="communityId"
                                [customerId]="cell.data.attribute"
                                [displayText]="cell.value"
                            ></app-property-community-link>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <dx-button
                                type="default"
                                text="Close"
                                hint="Close"
                                [icon]="iconClose"
                                (onClick)="closeSelector()"
                            ></dx-button>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
